/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import bus from "../../../bus";
import { playerEvents } from "../../events";
import { WrappedSvg } from "../../../utilities/hyperapp";

import playIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../player/play-icon.svg";
import pauseIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../player/pause-icon.svg";

const playStream = function(id) {
  bus.emit(playerEvents.SET, {
    status: "playing",
    target: {
      type: "stream",
      id
    }
  });
};

const pauseStream = function(id) {
  bus.emit(playerEvents.SET, {
    status: "paused",
    target: {
      type: "stream",
      id
    }
  });
};

const Stream = ({ id, name, currentItem, playing }) => {
  return (
    <button
      aria-label={`${playing ? "Pause" : "Play"} ${name}`}
      class={classNames({
        "d-flex": true,
        "flex-items-v-center": true,
        "player-stream": true,
        "player-stream--playing": playing
      })}
      onclick={e => {
        e.preventDefault();
        playing ? pauseStream(id) : playStream(id);
      }}
      ga-on="click,auxclick,contextmenu"
      ga-event-category="audio"
      ga-event-action={playing ? "pause" : "play"}
      ga-event-label={name}
    >
      <span
        class={classNames({
          "player-stream__icon": true,
          "player-stream__icon--playing": playing,
          "mr-xsmall": true,
          "d-flex": true,
          "flex-items-center": true
        })}
      >
        <span class="player-stream__play-icon">
          <WrappedSvg data={playIcon} height={11} width={8} />
        </span>
        <span class="player-stream__pause-icon">
          <WrappedSvg data={pauseIcon} height={11} width={8} />
        </span>
      </span>
      <span class="player-stream__label">
        {name}
        {currentItem ? (
          <span class="player-stream__subtitle">{currentItem}</span>
        ) : null}
      </span>
      <span class="player-stream__flag-label ml-small flag-label g-pink-purple">
        Live
      </span>
    </button>
  );
};

const Streams = ({
  isPlayerTarget,
  availableStreams,
  playerTarget,
  playerStatus
}) => {
  return (
    <div class="player-streams">
      {availableStreams.map(stream => {
        const playing =
          playerStatus === "playing" &&
          isPlayerTarget &&
          playerTarget &&
          playerTarget.currentItem().getPlayerItemID() === stream.id;
        return (
          <Stream
            id={stream.id}
            name={stream.name}
            currentItem={stream.current_item_name}
            playing={playing}
          />
        );
      })}
    </div>
  );
};

export default Streams;
